import { useRef, useState } from 'react'

interface Props {
  /** 表示する HTML 断片 */
  html: string
  /** iframe の title（読み上げ用） */
  title: string
  /** 表示する幅（px） */
  width: number
}

/**
 * HTML 断片を、画面の CSS の影響を受けない iframe で見本として表示する。高さは中身（画像の読み込み後を含む）に合わせる。
 *
 * - スクリプトは実行させない（sandbox に allow-scripts を付けない）
 * - 見本のリンクを押すと本物のクリックとして記録されてしまうため、操作はできないようにする
 * - 相対URLは親の画面と同じ配信元で解決される（srcdoc の iframe は親の URL を基準にする）
 */
const HtmlPreviewFrame = ({ html, title, width }: Props) => {
  const ref = useRef<HTMLIFrameElement>(null)
  const [height, setHeight] = useState(120)

  const fitHeight = () => {
    const body = ref.current?.contentDocument?.body
    if (body) setHeight(Math.max(40, body.scrollHeight))
  }

  const handleLoad = () => {
    fitHeight()
    ref.current?.contentDocument
      ?.querySelectorAll('img')
      .forEach((img) => img.addEventListener('load', fitHeight))
  }

  return (
    <iframe
      ref={ref}
      title={title}
      srcDoc={`<!doctype html><html><head><meta charset="utf-8"><style>html,body{margin:0;overflow:hidden;background:#fff}</style></head><body>${html}</body></html>`}
      sandbox='allow-same-origin'
      onLoad={handleLoad}
      className='border-secondary pointer-events-none box-content max-w-full rounded border bg-white'
      // 枠線の分で中身が狭くならないよう、幅・高さは中身の寸法で指定する（box-content）
      style={{ width, height }}
    />
  )
}

export default HtmlPreviewFrame
